module.exports = __webpack_public_path__ + "img/Weapon_181.61ef68d4.png";